import { Link } from "react-router-dom";
import ProfilePreview from "../../UserInterface/ProfilePreview";
import { UserType } from "../../../types/userType";
import styles from "./profileCell.module.scss";

const ProfileCell = ({
  data,
  admin = false,
  description,
  link = true,
}: {
  data: UserType;
  admin?: boolean;
  description?: string;
  link?: boolean;
}) => {
  if (!link)
    return (
      <ProfilePreview size="medium" description={description} user={data} />
    );
  return (
    <Link
      to={`${admin ? "/admin/" : "/"}user/${data.id}`}
      className={styles.profileLink}
    >
      <ProfilePreview size="medium" description={description} user={data} />
    </Link>
  );
};

export default ProfileCell;
